// <copyright company="Microsoft">Copyright (c) Microsoft. All rights reserved.</copyright>

import EInvoicingConfiguration from '../../config/config.type';

/**
 * Determines whether the Manual Invoice Creator feature is enabled for the given
 * configuration. Fail-closed: only an explicit `true` enables the feature, so a
 * missing flag or missing featureFlags block (e.g. an environment where the flag
 * was never set) keeps the feature disabled.
 */
export const isManualInvoiceCreatorEnabled = (config: EInvoicingConfiguration): boolean =>
    config.featureFlags?.manualInvoiceCreator === true;
